import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=54e0299f&"
import script from "./HelpIcon.vue?vue&type=script&lang=js&"
export * from "./HelpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports